import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import DonorsHub from "@/pages/DonorsHub";
import RecipientsHub from "@/pages/RecipientsHub";
import DropoutHub from "@/pages/DropoutHub";
import ExpensesHub from "@/pages/ExpensesHub";
import AdminHub from "@/pages/AdminHub";
import ReportsHub from "@/pages/ReportsHub";
import ImportHub from "@/pages/ImportHub";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="flex items-center justify-center h-screen bg-[#F8F9FA]">
      <div className="text-[#0F6CBD] text-lg font-medium" data-testid="loading-indicator">Loading...</div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="flex items-center justify-center h-screen bg-[#F8F9FA]">
      <div className="text-[#0F6CBD] text-lg font-medium">Loading...</div>
    </div>
  );

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="donors/*" element={<DonorsHub />} />
        <Route path="recipients/*" element={<RecipientsHub />} />
        <Route path="dropouts/*" element={<DropoutHub />} />
        <Route path="expenses/*" element={<ExpensesHub />} />
        <Route path="admin/*" element={<AdminHub />} />
        <Route path="reports/*" element={<ReportsHub />} />
        <Route path="import/*" element={<ImportHub />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
